var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductionPrepareTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-productionPrepareTime"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-productionPrepareTime",
    clipPath: "url(#clip-icon-productionPrepareTime)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M824.068,326.492l49.949-49.949a31.316,31.316,0,0,0,0-44.288h0a31.317,31.317,0,0,0-44.289,0l-47.736,47.736A392.145,392.145,0,0,0,542.081,173.922V136.3c-.022-.246-.034-.5-.034-.76s.012-.515.034-.761a8.95,8.95,0,0,1,8-8.142,9.364,9.364,0,0,1,1.834,0H619.96a31.317,31.317,0,0,0,0-62.634H403.895a31.328,31.328,0,0,0-31.172,28.275v6.084a31.328,31.328,0,0,0,31.172,28.275h66.6a8.945,8.945,0,0,1,8.948,8.948v38.531C277.285,190.655,118.385,359.967,118.385,566.391,118.385,783.775,294.61,960,511.994,960S905.615,783.775,905.615,566.391A391.874,391.874,0,0,0,824.068,326.492ZM746.033,800.429A330.976,330.976,0,1,1,479.447,236.981q16.124-1.56,32.547-1.565,15.166,0,30.087,1.342A330.992,330.992,0,0,1,746.033,800.429Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 62.634,
    height: 263.964,
    rx: 28,
    transform: "translate(480.683 345.081)",
    fill: "#5797d2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductionPrepareTime);
export default __webpack_public_path__ + "static/media/icon-productionPrepareTime.105e3d7c8dd9cae65de3d13e7ed2f350.svg";
export { ForwardRef as ReactComponent };